import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

export type User = {
	id: string
	oauthId: string
	display: string
	picture: string
	likes?: Comment[]
	dislikes?: Comment[]
	bookmarks?: Comment[]
	authorOf?: Comment[]
	starterOf?: Conversation[]
	unreadMessagesInConversations?: Conversation[]
}

export type Attachment = {
	id: string
	name: string
	createdAt: Date
	mediaType: string
	comment: Comment
}

export type Comment = {
	id: string
	author: User
	content: string
	createdAt: Date
	parentConversation: { id: string }
	parentComment?: { id: string }
	comments: Comment[]
	bookmarkedBy: User[]
	likedBy: User[]
	dislikedBy: User[]
	attachments?: Attachment[]
}

export type Conversation = {
	id: string
	parent: Parent
	organization: string
	bookmarkedBy: User[]
	title: React.ReactNode
	author: User
	createdAt: Date
	comments?: Comment[]
	unreadMessagesBy?: User[]
}

export type Parent = {
	id: string
	parent: string
	type: ParentType
	conversations?: Conversation[]
}

export enum ParentType {
	Organization,
	Portfolio,
	Project,
	WbsComponent,
	WorkItem
}
